<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="付款单号：">
                <el-input v-model.trim="searchForm.orderNo" @keyup.enter.native="getRecorListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="第三方单号：">
                <el-input v-model.trim="searchForm.payOrder" @keyup.enter.native="getRecorListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号/虚拟号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getRecorListHandler" clearable></el-input>
            </el-form-item>
			<el-form-item label="充值日期：" >
			    <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
			</el-form-item>
            <el-form-item label="支付状态：">
                <el-select v-model="searchForm.payState" clearable>
                    <el-option label="已退款" value="3"></el-option>
                    <el-option label="退款中" value="2"></el-option>
                    <el-option label="已支付" value="1"></el-option>
                    <el-option label="未支付" value="0"></el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="代理商：">
                <el-select v-model="searchForm.agentId"  @change="getAgentPkgSoldListPageHandle" filterable>
                    <el-option v-for="item in agentListOption" :value="item.id" :key="item.id" :label="item.name+'（'+item.sysUserAccountName+'）'"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getRecorListHandler">搜索查询</el-button>
                 <el-button type="success"  @click="exportSimInfoHandle">导出Excel</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column type="index" label="序号"></el-table-column> 
            <el-table-column prop="orderNo" label="付款单号"></el-table-column>   
            <el-table-column prop="payOrder" label="第三方单号"></el-table-column>    
            <el-table-column label="ICCID号" >
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToUserBalance(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column  label="付款金额 （元）" width="120">
                <template slot-scope="scope">
                    {{scope.row.amount/100}}
                </template>
            </el-table-column>
            <el-table-column  label="支付类型" width="120">
                <template slot-scope="scope">
                    {{scope.row.payTypeName}}
                </template>
            </el-table-column>


            <el-table-column  label="支付状态" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.payState==1" style="color:green">已支付</span>
                    <span v-else-if="scope.row.payState==2" style="color:blue">退款中</span>
                    <span v-else-if="scope.row.payState==3" style="color:green">已退款</span>
                    <span v-else-if="scope.row.payState==-1" style="color:red">订单不存在</span>
                    <span v-else-if="scope.row.payState==0" style="color:red">未支付</span>
                    <span v-else  style="color:red">未知状态</span>
                </template>
            </el-table-column> 
            <el-table-column prop="sysRemark" label="系统备注" width="160"></el-table-column>    

            <el-table-column prop="createTime" label="付款时间" width="160"></el-table-column>
             <el-table-column prop="returnTime" label="退款时间" width="160"></el-table-column>
               <el-table-column prop="subId" label="商户号" width="100"></el-table-column>

            <el-table-column  label="操作" width="200">
                <template v-slot="scope">
                    <el-button type="text" size="small" v-if="scope.row.payState==1" @click="showRefundDialog(scope.row)">处理退款</el-button>
                    <el-button type="text" size="small" v-if="scope.row.payState == 1"
                        @click="changeToPkgs(scope.row.orderNo)">转余额</el-button>
                </template>
            </el-table-column>
        </el-table>
        
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>


        <el-dialog :append-to-body="true"  title="处理退款" :visible.sync="refundDialogVisible" width="600px" :close-on-click-modal="false" @close="cancelRefund()">
            <el-form ref="refundForm" :model="refundForm" :rules="refundRules" label-width="140px">
                <el-form-item label="付款单号：" >
                    <span>{{refundForm.orderNo}}</span>
                </el-form-item>

                <el-form-item label="退款金额(元)：" prop="priceRmb">
                    <el-input-number v-model="refundForm.priceRmb" :precision="2" :step="1" :min="0" :max="maxPriceRmb" clearable></el-input-number>
                </el-form-item>

                <el-form-item label="退款原因：" >
                    <el-input v-model="refundForm.remark" type="textarea"  maxlength="50" clearable></el-input>
                </el-form-item>

                <el-form-item label="退款类型：" prop="sysRemark">
                    <el-radio-group v-model="refundForm.sysRemark">
                        <el-radio label="退款-线下">退款-线下</el-radio>
                        <el-radio label="退款-线上">退款-线上</el-radio>
                    </el-radio-group>
                </el-form-item>


                <el-form-item label="凭证截图：" >
                    <el-upload class="avatar-uploader" action=""
                        :show-file-list="false"
                        :auto-upload="false"
                        :on-change="handleAvatarSuccess">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>   
            <div slot="footer" class="dialog-footer">
            <p style="color:red">点击 确定 后，VIP会员会立即失效</p>
                <el-button @click="cancelRefund()">取 消</el-button>
                <el-button type="primary" @click="applyRefundUser()">确 定</el-button>
            </div>       

        </el-dialog>

         <el-dialog
      :append-to-body="true"
      title="批量退款"
      :visible.sync="importVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form :model="dealWithForm" label-width="120px">
        <el-form-item label="导入Excel：" prop="uploadExcel">
          <el-upload
            ref="upload"
            :action="uploadUrl('batch/change/batch/back/order')"
            :headers="setHeader()"
            :limit="1"
            :auto-upload="false"
            :on-success="handleSuccess"
          >
            <el-button slot="trigger" plain>导入Excel</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importCancel">取 消</el-button>
        <el-button type="primary" @click="importApplyHandler">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog :append-to-body="true" class="formDialog"  title="赠送金转套餐" :visible.sync="changeFlg" width="600px" @close="changeCancel" :close-on-click-modal="false">
            <el-form ref="changeData" :model="changeData" label-width="120px">  

                  <el-form-item label="套餐流量:" prop="totalData" >
                    <el-col >
                        <el-input v-model.trim="changeData.totalData"  placeholder="单位/G" clearable></el-input>
                    </el-col>                    
                </el-form-item>


                <el-form-item label="套餐数量:" prop="pkgSize" >
                    <el-col >
                        <el-input v-model.trim="changeData.pkgSize"  placeholder="请输入套餐个数" clearable></el-input>
                    </el-col>                    
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeCancel">取 消</el-button>
                <el-button type="primary" @click="changeSure()">确 定</el-button>
            </div>            
        </el-dialog>


        
        <el-dialog :append-to-body="true"  title="添加优惠券" :visible.sync="changeStateVisible1" width="600px" @close="changeStateCancel" :close-on-click-modal="false">
            <el-form ref="changeStateForm" :model="changeStateForm"  label-width="100px">
                <el-form-item label="ICCID：" prop="iccid">
                    <el-input v-model="changeStateForm.iccid" placeholder="卡号 "></el-input>
                </el-form-item>
                <el-form-item label="订单号：" prop="orderNo">
                    <el-input v-model="changeStateForm.orderNo" placeholder="订单号 "></el-input>
                </el-form-item>
                <el-form-item label="券金额/元：" prop="price">
                    <el-input v-model="changeStateForm.price"  placeholder="卷的面额"></el-input>
                </el-form-item>
                <el-form-item label="券的数量：" prop="priceSize">
                    <el-input v-model="changeStateForm.priceSize" placeholder="卷的数量"></el-input>
                </el-form-item>
           
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeStateCancel">取 消</el-button>
                <el-button type="primary" @click="sureChangeStateHandler1">确 定</el-button>
            </div> 
        </el-dialog>


        <el-dialog :append-to-body="true" class="formDialog" title="转送余额" :visible.sync="changeFlgs" width="600px"
            @close="changeCancels" :close-on-click-modal="false">
            <el-form ref="changeData" :model="changeData" label-width="120px">
                <el-form-item label="转送余额:" prop="totalData">
                    <el-col>
                        <el-input v-model.trim="changeData.totalData" placeholder="单位/元" clearable></el-input>
                    </el-col>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeCancels">取 消</el-button>
                <el-button type="primary" @click="changeSures()">确 定</el-button>
            </div>
        </el-dialog>

                 
    </div>
</template>
<script>
import {getBalanceRechargeRecordListVip,exportSimInfoVip,exportSimInfo1} from '@/api/record.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            changeStateVisible1:false,
            importVisible:false,
            searchForm: {
                iccid: '',
                orderNo: '',
                payOrder: null,
                payState:null,
				time: '',
                agentId:''

            },
             agentListOption: [],
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

            refundDialogVisible: false,
            refundForm:{
                orderNo: '',
                priceRmb: '',
                remark: '',
                sysRemark:'',
                file: null,
            },
            maxPriceRmb:0,
            imageUrl: '',

            refundRules:{
                priceRmb: { required: true, message: '必填项', trigger: 'blur' },
            },
            changeFlg:false,
            changeData:{
                orderNo:'',
                totalData:'',
                pkgSize:''
            },

            changeStateForm: {
                state: '',
                remark: '',
                 name: '',
                price: '',
                 priceSize: '',
                orderNo: '',
                iccid:''
            },

            changeFlgs: false,
            
        }
    },
    methods: {

        changeToPkgs(orderNo) {
            this.changeData.orderNo = orderNo;
            this.changeFlgs = true;
        },
        changeCancels() {
            this.changeFlgs = false;
        },
        changeSures() {
            common
                .sysRequest("pkg/group/change/to/yu", this.changeData, "post")
                .then((res) => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.changeFlgs = false;
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => console.error(err));
        },



        
        changeStateCancel(){
            this.changeStateVisible1 = false;
        },
        sureChangeStateHandler1(){
             common.sysRequest('import/sim/state/insert/price', this.changeStateForm, 'post').then(res => {
                if(res.data.code == 200){
                     this.$message.success(res.data.message);
                    this.changeStateVisible1 = false;
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },     
        showChangeCardStateHandler1(){
           this.changeStateVisible1 = true;
            
        },


        changeToPkg(orderNo){
            this.changeData.orderNo=orderNo;
            this.changeFlg=true;
        },
        changeCancel(){
            this.changeFlg=false;
        },
        changeSure(){

        },
         changeSure(){
        common
        .sysRequest("pkg/group/change/to/pkg", this.changeData, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message);
            this.changeFlg=false;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));
    },




         showImportApply() {
      this.importVisible = true;
    },
      importApplyHandler() {
      this.$refs.upload.submit();
    },
         handleSuccess(res) {
      if (res.code == 200) {
        this.importVisible = false;
        this.$refs.upload.clearFiles();
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
    },
          importCancel() {
      this.importVisible = false;
    },
           exportSimInfoHandle(){//导出excel文件
            this.$confirm("您确定要导出余额订单列表吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
                 common.deleteSpaceKey(this.searchForm); 
                exportSimInfoVip(this.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去下载专区下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err)); 
            })          
        },
         exportSimInfoHandle1(){//导出excel文件
            this.$confirm("您确定要导出赠送金订单列表吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
                 common.deleteSpaceKey(this.searchForm); 
                exportSimInfo1(this.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去下载专区下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err)); 
            })          
        },
        getRecorListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);   
            getBalanceRechargeRecordListVip(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })    
        },

        goToUserBalance(row){
            this.$store.commit('menu/setFromPage', 'balanceRechargeRecord');
            this.$store.commit('menu/setIccidToAccount', row.iccid);
            document.getElementById('userBalanceMenu').click();
        },

      
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getRecorListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getRecorListHandler();
        },


        showRefundDialog(data){
            this.refundForm.orderNo = data.orderNo;
            if(data.giftBalance){
                this.maxPriceRmb = (data.amount + data.giftBalance)/100;
            }else{
                this.maxPriceRmb = data.amount/100;
            }
            
            this.refundDialogVisible = true;
        },

        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(res.raw);
            this.refundForm.file = res.raw;
        },

        beforeAvatarUpload(file) {
            if(file){
                let isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
                let isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                  this.$message.error('上传的图片只能是 JPG 或 PNG 格式!');
                }
                if (!isLt2M) {
                  this.$message.error('上传的图片大小不能超过 2MB!');
                }
                this.refundForm.file = file;
                return isJPG && isLt2M;
            }
            
            return true;
        }, 

        cancelRefund(){
            this.refundForm.priceRmb = '',
            this.refundForm.remark = '',
            this.refundForm.file = null;
            this.imageUrl = null;
            this.refundDialogVisible = false;
        },

        applyRefundUser(){
            if(this.refundForm.priceRmb == 0){
                this.$message.error("退款金额不能为0");
                return;
            }
            this.$refs.refundForm.validate(valid => {
                if(valid) {
                    if(this.beforeAvatarUpload(this.refundForm.file)){
                        let formData = new FormData();
                        Object.keys(this.refundForm).forEach((key) => {
                            formData.append(key, this.refundForm[key]);
                        });
                        common.sysRequest('order/applyRefundUser/vip', formData, 'post').then(res => {
                            if(res.data.code == 200){
                                this.$message.success(res.data.message);
                                this.cancelRefund();
                                this.getRecorListHandler();
                            }else{
                               this.$message.error(res.data.message); 
                            }
                        })
                    }
                }
            })
        },

        investOrder(orderNo){
            common.sysRequest('order/sync/user/investOrder/'+orderNo, {}, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.getRecorListHandler();
                }else{
                   this.$message.error(res.data.message); 
                }
            })
        },
        
    },
    created () {
         common.getAgentListOptionCom(this, 'agentListOption');
    },

    mounted () {
       
        let fromPage = this.$store.state.menu.fromPage;
        let fromPageOrderNo = this.$store.state.menu.fromPageOrderNo;
        if(fromPage == 'userAccountFlowRecord'){
            this.searchForm.orderNo = fromPageOrderNo;
            this.getRecorListHandler();
            this.$store.commit('menu/setFromPage', '');
            this.$store.commit('menu/setFromPageOrderNo', '');
        }
        else{
            this.getRecorListHandler();
        }

        
    },

    computed:{
        fromPageOrderNo: function(){
            return this.$store.state.menu.fromPageOrderNo;
        },
    },

    watch: {
        fromPageOrderNo: function () {
            let fromPage = this.$store.state.menu.fromPage;
            let fromPageOrderNo = this.$store.state.menu.fromPageOrderNo;
            if(fromPage == 'userAccountFlowRecord'){
                this.searchForm.orderNo = fromPageOrderNo;
                this.getRecorListHandler();
                this.$store.commit('menu/setFromPage', '');
                this.$store.commit('menu/setFromPageOrderNo', '');
            }
        }
    },
}
</script>
<style lang="less" scoped>
    el-upload {
        border: 1px dashed #d9d9d9;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
        border: 1px dashed #d9d9d9;
    }
</style>

